import { useEffect, useState } from 'react';
import { statusClass } from '../utils/Utils';
import './Status.scss';

function Status({ user }) {
  const [status, setStatus] = useState('--nologin');

  useEffect(() => {
    if (user.vaccine) {
      setStatus(statusClass(user.vaccine.vaccine_status));
    }
  }, [user]);

  return <div className={`covidtest shadow ${status}`}></div>;
}

export default Status;
